import { createAction } from '@ngrx/store'

export const clearSelectedPaymentMethod = createAction('[Payment/Page] Clear Selected Payment Method')

export const cancelPayment = createAction('[Payment/Page] Cancel Payment')
